import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-storage-setting',
  templateUrl: './power-storage-setting.component.html',
  styleUrls: ['./power-storage-setting.component.css']
})
export class PowerStorageSettingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
